 <template>
  <!-- Left side column. contains the logo and sidebar -->
  <nav
    class="nav-menu left-side-menu"
    role="navigation"
    :class="isFullScreen ? 'full-screen-menu' : ''"
    key="nav"
  >
    <div class="background" />
    <ul class="nav-item-list">
      <template v-for="item in menuitems">
        <li
          class="menu-item"
          v-if="item.link"
          :link="item.link"
          :icon="item.icon"
          v-bind:key="item.link"
        >
          <router-link :to="item.link" class="menu-link">
            <v-icon class="menu-icon">{{ item.icon }}</v-icon>
            <span class="menu-label">{{ item.name }}</span>
          </router-link>
        </li>
      </template>
      <li class="menu-item">
        <button @click="logout" class="menu-link">
          <v-icon class="menu-icon">fa-lock</v-icon>
          <span class="menu-label">Logout</span>
        </button>
      </li>
    </ul>
    <div class="label-background" />
  </nav>
</template>

<script>
import menuItems from "@/menu.js";
import adminMenuItems from "@/admin-menu.js";

export default {
  name: "NavMenu",
  props: ["isFullScreen"],
  components: {},
  computed: {
    menuitems() {
      let usertype = this.$cookies.get("type");
      if (usertype == "true") {
        return adminMenuItems;
      } else {
        return menuItems;
      }
    },
  },
  methods: {
    logout: function () {
      this.$cookies.remove("email");
      this.$cookies.remove("token");
      this.$cookies.remove("type");
      window.location.reload();
    },
  },
};
</script>

<style scoped lang="scss">
@import "./css/customvariables";

.nav-menu {
  transition: all 0.33s ease-in-out;
  background: #ddd;

  width: 4rem;
}

.background {
  height: 100%;
  overflow-y: auto;
  position: fixed;
  top: 64px;
  left: 0;
  right: auto;
  background: $leftmenu_color;
  width: 4rem;
}

.menu-item {
  background: $leftmenu_color;
  color: white;
  position: relative;
}
.menu-item:hover {
  background: #5d5d5d;
}

.nav-item-list {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 4rem;
  transition: all 0.3s;
}

li {
  position: relative;
}

.menu-link {
  display: inline-flex;
  position: relative;
  width: 100%;
}

.menu-icon {
  padding: 1.25rem;
  min-width: 4rem;
  color: #eee !important;
}

.menu-label {
  opacity: 0;
  color: black;

  font-size: 1.25rem;
  padding-left: 1.5rem;
  opacity: 0;
  z-index: 5001;

  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: opacity 0.3s ease-in-out;
  min-width: 18rem;
}

.nav-menu:hover .menu-label {
  opacity: 1;
}

.menu-item:hover .menu-label {
  background: #eee;
}

.full-screen-menu {
  position: absolute;
  top: 64px;
  left: 0;
  width: 100% !important;
  height: calc(100vh - 64px) !important;
  background: #ddd;
  overflow-y: auto;
  overflow-x: hidden;

  .menu-label {
    opacity: 1;
    min-width: calc(100vw - 64px - 1.5rem);
  }
}
</style>
